import { render } from "./ui-day-selector.vue?vue&type=template&id=1e0d0360&ts=true"
import script from "./ui-day-selector.vue?vue&type=script&lang=ts"
export * from "./ui-day-selector.vue?vue&type=script&lang=ts"

import "./ui-day-selector.vue?vue&type=style&index=0&id=1e0d0360&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__